export default function (Vue) {
  const loading = {
    show: () => {
      Vue.prototype.$loading(true);
    },
    hide: () => {
      Vue.prototype.$loading(false);
    },
  };

  Object.defineProperties(Vue.prototype, {
    $loader: {
      get: () => {
        return loading;
      },
    },
  });
}
